import {APP, GAME_STATUSES} from "../../app/consts";
import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class PredictionShowEvent extends BaseAnalyticsEvent {
  entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES;
  screen: APP.ANALYTICS.SCREENS;
  screenId: Number;
  status: GAME_STATUSES;
  isContextual: Boolean;
  contextualUsed: Boolean;
  tabName: String;

  constructor(params) {
    super('', 'show', 'prediction');

    this.entityType = params.entityType;
    this.screen = params.screen;
    this.screenId = params.screenId;
    this.status = params.status;
    this.isContextual = params.isContextual;
    this.contextualUsed = params.contextualUsed;
    this.tabName = params.tabName;
  }

  get properties() {
    const properties = super.properties;

    properties.entityType = this.entityType;
    properties.screen = this.screen;
    properties.screenId = this.screenId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.isContextual = this.isContextual;
    properties.contextualUsed = Number(this.contextualUsed);
    properties.tabName = this.tabName;

    return properties;
  }
}
